import { render } from "./WeekReport.vue?vue&type=template&id=b2e50928"
import script from "./WeekReport.vue?vue&type=script&lang=ts"
export * from "./WeekReport.vue?vue&type=script&lang=ts"
script.render = render

export default script